export const PHONE_REGEX_WITHOUT_91 = /^[1-9]{1}[0-9]{9}$/;
export const DOUBLE_WHITESPACES = /^(?!.* {2}).+/;
export const PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?.!@$%/^&*-]).{8,}$/;